export const CSM_STANDARD_LENGTHS = [
  72, 84, 96, 108, 120, 132, 144, 156, 168, 180, 192, 204, 216, 228,
  240,
];

export const CSM_STANDARD_WIDTHS = [72, 78, 84, 90, 96, 98, 102];

const CSM_RESTRICTED_LENGTHS_BY_WIDTH = {
  72: [96, 108, 132, 144],
  78: [72, 84, 96, 108, 120, 132, 144, 156, 168, 180],
};

const getNearestValue = (value, candidates) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || candidates.length === 0) {
    return null;
  }

  return candidates.reduce((nearest, candidate) =>
    Math.abs(candidate - numericValue) < Math.abs(nearest - numericValue)
      ? candidate
      : nearest
  );
};

export const isCsmStandardLength = (length) =>
  CSM_STANDARD_LENGTHS.includes(Number(length));

export const isCsmStandardWidth = (width) =>
  CSM_STANDARD_WIDTHS.includes(Number(width));

export const isCsmStandardSize = (length, width) => {
  const numericLength = Number(length);
  const numericWidth = Number(width);

  if (!isCsmStandardLength(numericLength) || !isCsmStandardWidth(numericWidth)) {
    return false;
  }

  const restrictedLengths = CSM_RESTRICTED_LENGTHS_BY_WIDTH[numericWidth];
  return restrictedLengths
    ? restrictedLengths.includes(numericLength)
    : true;
};

export const getNearestCsmValidLength = (length, width) => {
  const numericWidth = Number(width);
  const restrictedLengths = CSM_RESTRICTED_LENGTHS_BY_WIDTH[numericWidth];
  const candidates = isCsmStandardWidth(numericWidth)
    ? restrictedLengths || CSM_STANDARD_LENGTHS
    : CSM_STANDARD_LENGTHS;

  return getNearestValue(length, candidates);
};

export const getNearestCsmValidWidth = (length, width) => {
  const numericLength = Number(length);
  const candidates = isCsmStandardLength(numericLength)
    ? CSM_STANDARD_WIDTHS.filter((candidateWidth) =>
        isCsmStandardSize(numericLength, candidateWidth)
      )
    : CSM_STANDARD_WIDTHS;

  return getNearestValue(width, candidates);
};

export const isCsmWindRatedSize = (length, width) => {
  const numericLength = Number(length);
  const numericWidth = Number(width);

  return (
    isCsmStandardSize(numericLength, numericWidth) &&
    numericWidth >= 84 &&
    numericLength >= 96
  );
};
